var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 11H17C18.104 11 19 11.896 19 13V17C19 18.104 18.103 19 17 19H12C5.383 19 0 13.617 0 7V2C0 0.896 0.897 0 2 0H6C7.103 0 8 0.896 8 2V6C8 7.072 7.153 7.949 6.092 7.998C6.528 10.582 8.459 12.518 11.001 12.922C11.042 11.855 11.923 11 13 11ZM2 7C2 12.514 6.486 17 12 17H17.001L17 13H13V14C13 14.553 12.552 15 12 15C7.512 15 4.073 11.567 4 7.016C3.997 6.748 4.099 6.491 4.287 6.299C4.475 6.107 4.732 6 5 6H6V2H2V7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2V0H19V8H17V3.414L10.708 9.707L9.29297 8.293L15.586 2H11Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "phone.9d961d270211877a69a0a006c947a93d.svg";